export default {
  getCourses({state, commit}) {
    if (state.coursesFetchStatus) return state.courses

    return new Promise((resolve, reject) => {
      axios.get('/api/v1/credential/courses')
          .then(({data}) => {
            commit('SET_COURSES', data);
            commit('SET_COURSES_FETCH_STATUS', 'all');
            resolve(state.courses);
          })
          .catch(({response}) => reject(response))
    })
  },

  getLatestCourses({state, commit}) {
    if (state.latestCoursesFetchStatus) return state.latestCourses

    return new Promise((resolve, reject) => {
      axios.get('/api/v1/credential/courses?latest&limit=8')
          .then(({data}) => {
            commit('SET_COURSES_LATEST', data);
            commit('SET_LATEST_COURSES_FETCH_STATUS', 'all');
            resolve(state.latestCourses);
          })
          .catch(({response}) => reject(response))
    })
  },

  getPopularCourses({state, commit}) {
    if (state.popularCoursesFetchStatus) return state.popularCourses

    return new Promise((resolve, reject) => {
      axios.get('/api/v1/credential/courses?popular&limit=8')
          .then(({data}) => {
            commit('SET_POPULAR_COURSES', data);
            commit('SET_POPULAR_COURSES_FETCH_STATUS', 'all');
            resolve(state.popularCourses);
          })
          .catch(({response}) => reject(response))
    })
  },

  getMemberCourses({state, commit}, { memberId }) {
    if (state.memberCourses.length) return state.memberCourses
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/credential/members/${memberId}/courses?include=course`)
          .then(({data}) => {
            commit('SET_MEMBER_COURSES', data);
            resolve(data);
          })
          .catch(({response}) => reject(response))
    })
  },

  findCourseBySlug({ state, commit }, { slug }) {
    const cache = state.courses[slug]

    if (cache) {
      return cache
    }

    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/credential/courses/${slug}`)
          .then(({data}) => resolve(data))
          .catch(({response}) => reject(response))
    })
  },

  findMemberCourse({ state, commit }, { memberId, course, query }) {
    const cache = state.memberLearning[course.slug]

    if (cache) return cache

    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/credential/members/${memberId}/courses/${course.id}?${query}`)
          .then(({data}) => {
            commit('ADD_MEMBER_LEARNING', { course, memberCourse: data })

            resolve(data)
          })
          .catch(({response}) => reject(response))
    })
  },

  getUnitResources({ state, commit }, { unitId, moduleOrder, unitOrder, slug }) {
    const cachedKey = `m${moduleOrder}u${unitOrder}`

    const cached = _.get(state.resources, `[${slug}][${cachedKey}]`)

    if (cached) return cached

    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/credential/units/${unitId}/resources`)
          .then(({data}) => {
            commit('ADD_RESOURCES', {key: cachedKey, slug, resources: data})

            resolve(state.resources[slug][cachedKey])
          })
          .catch(e => reject(e))
    })
  },

  getUnitAssessment({ state, commit }, { unitId, moduleOrder, unitOrder, slug }) {
    const cachedKey = `m${moduleOrder}u${unitOrder}`

    const cached = _.get(state.assessments, `[${slug}][${cachedKey}]`)

    if (cached) return cached

    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/credential/units/${unitId}/assessment?include=choices`)
          .then(({data}) => {
            commit('ADD_ASSESSMENT', {slug, key: cachedKey, assessment: data})

            resolve(data)
          })
          .catch(({response}) => reject(response))
    })
  },

  updateMemberUnitAssessment({ state, commit }, { memberUnit, answers, mark, slug, moduleOrder }) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/v1/credential/members/${memberUnit.memberId}/modules/${memberUnit.unit.moduleId}/units/${memberUnit.unitId}`, {
        answers,
        mark: !!mark
      })
        .then(({data}) => {
          const path =  `memberLearning[${slug}].modules[${moduleOrder}].units[${memberUnit.unit.orderIndex}]`
          commit('UPDATE_MEMBER_UNIT', {data, path})
          resolve(data)
        })
        .catch(({response}) => reject(response))
    })
  },

  getBadges({state, commit}, { userId }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/users/${userId}/badges?include=badge`)
          .then(({data}) => {
            commit('SET_BADGES', data);
            resolve(state.badges);
          })
          .catch(({response}) => reject(response))
    })
  },

  updateProfile({}, { inputs, memberId }) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/v1/credential/members/${memberId}`, inputs)
          .then(({data}) => resolve(data))
          .catch(({response}) => reject(response))
    });
  },

  getRecentViewedCourse({commit, state}, memberId) {
    return new Promise((resolve, reject) => {
      if (state.recentViewedCourse) {
          return resolve(state.recentViewedCourse);
      }
      axios.get(`/api/v1/credential/members/${memberId}/recent-course`)
          .then(({data}) => {
            if (data) {
                commit('SET_RECENT_VIEWED_COURSE', data);
                resolve(data);
            }
          })
          .catch(({response}) => reject(response))
    });
  },

  saveRecentViewedCourse({commit}, {memberId, course}) {
    return new Promise((resolve) => {
        axios.patch(`/api/v1/credential/members/${memberId}/recent-course`, {courseId: course.id})
            .then(({data}) => {
                commit('UPDATE_RECENT_VIEWED_COURSE', data);
                resolve(data);
            });
    });
  },
}
